import React from "react";
import PropTypes from "prop-types";
import "spectre.css/dist/spectre.min.css";
import "spectre.css/dist/spectre-exp.min.css";

import "./index.css";
import Header from "./header";
import Footer from "./footer";

const propTypes = {
  children: PropTypes.func.isRequired,
};

function Layout({ children }) {
  return (
    <div style={{ maxWidth: "64rem", marginLeft: "auto", marginRight: "auto" }}>
      <Header />
      <div className="container">{children}</div>
      <Footer />
    </div>
  );
}

Layout.propTypes = propTypes;

export default Layout;
